module.exports = __webpack_public_path__ + "img/backward.7f048ef9.svg";